import React, { useState } from 'react'
import { useStrategyDetails } from './hooks'
import {
  CCol,
  CNav,
  CNavItem,
  CNavLink,
  CRow,
  CTabContent,
  CTabPane,
} from '@coreui/react-pro'
import { StrategyDetailTabs } from './constants'
import { StrategyGeneral } from './general/page'
import { StrategyPerformance } from './perfomance'
import { InvestorsList } from './investor'
import { StrategyCommissions } from './commissions'

export const StrategyDetail = () => {
  const [activeClientTab, setActiveClientTab] = useState(1)
  const { strategy, loading } = useStrategyDetails()

  return (
    <div>
      <CRow>
        <CCol xs={10}>
          <CNav variant="tabs" role="tablist">
            {StrategyDetailTabs.map((item) => (
              <CNavItem key={item.id}>
                <CNavLink
                  data-tab={item.value}
                  href="#!"
                  active={activeClientTab === item.id}
                  onClick={() => setActiveClientTab(item.id)}
                >
                  {item.title}
                </CNavLink>
              </CNavItem>
            ))}
          </CNav>
          <CTabContent className="pt-3">
            <CTabPane
              data-tab="detail"
              role="tabpanel"
              aria-labelledby="contact-tab"
              visible={activeClientTab === 1}
            >
              <CRow>
                <StrategyGeneral data={strategy} />
              </CRow>
            </CTabPane>
            <CTabPane
              data-tab="detail"
              role="tabpanel"
              aria-labelledby="contact-tab"
              visible={activeClientTab === 2}
            >
              <CRow>
                <StrategyPerformance
                  data={strategy.strategyPerformances[0]}
                  aiMagic={strategy.aiMagic}
                />
              </CRow>
            </CTabPane>
            <CTabPane
              data-tab="investors"
              role="tabpanel"
              aria-labelledby="contact-tab"
              visible={activeClientTab === 3}
            >
              <CRow>
                {strategy.id != 0 && <InvestorsList strategyId={strategy.id} />}
              </CRow>
            </CTabPane>
            <CTabPane
              data-tab="detail"
              role="tabpanel"
              aria-labelledby="contact-tab"
              visible={activeClientTab === 4}
            >
              <CRow>
                {strategy.id != 0 && (
                  <StrategyCommissions strategyId={strategy.id} />
                )}
              </CRow>
            </CTabPane>
          </CTabContent>
        </CCol>
      </CRow>
    </div>
  )
}
